import React from "react";
// React Table
import { Container, Row, Col, Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";
// Utils
import { tiposEducacionObra } from "../../../../contexto";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaEducativos = ({ datosEducativos }) => {
  return (
    <Container>
      <Row xs={1} lg={3}>
        {Object.keys(tiposEducacionObra).map((tipoEducacion) => {
          return datosEducativos[tipoEducacion]?.nPeopleM || datosEducativos[tipoEducacion]?.maxNumberM || datosEducativos[tipoEducacion]?.maxCap ? (
            <Col key={tipoEducacion}>
              <b className="text-nowrap">{tiposEducacionObra[tipoEducacion]}</b>
              <Table bordered responsive>
                <tbody>
                  <tr>
                    <CustomTd>
                      <span>Capacidad máxima</span>
                    </CustomTd>
                    <td>{datosEducativos[tipoEducacion]?.maxCap !== null ? datosEducativos[tipoEducacion]?.maxCap : <small>No especificado </small>}</td>
                  </tr>
                  <tr>
                    <CustomTd>
                      <span>Varones</span>
                    </CustomTd>
                    <td>{datosEducativos[tipoEducacion]?.nPeopleM !== null ? datosEducativos[tipoEducacion]?.nPeopleM : <small>No especificado </small>}</td>
                  </tr>
                  <tr>
                    <CustomTd>
                      <span>Mujeres</span>
                    </CustomTd>
                    <td>{datosEducativos[tipoEducacion]?.nPeopleF !== null ? datosEducativos[tipoEducacion]?.nPeopleF : <small>No especificado </small>}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          ) : null;
        })}
      </Row>
    </Container>
  );
};

export default VistaEducativos;
